module.exports = __webpack_public_path__ + "static/media/50-day.3a91511a.png";